import React from 'react';
import { Box } from '@mui/material';

// Mapping currency short codes or names to country ISO 2-letter codes for flagcdn.com
const COUNTRY_CODE_MAP = {
  USD: 'us',
  EUR: 'eu',
  GBP: 'gb',
  CAD: 'ca',
  AUD: 'au',
  AED: 'ae',
  TRY: 'tr',
  CHF: 'ch',
  JPY: 'jp',
  CNY: 'cn',
  SAR: 'sa',
  INR: 'in',
  RUB: 'ru',
  IQD: 'iq',
  KWD: 'kw',
  QAR: 'qa',
  OMR: 'om',
  BHD: 'bh',
  SGD: 'sg',
  HKD: 'hk',
  NZD: 'nz',
  SEK: 'se',
  NOK: 'no',
  DKK: 'dk',
  MYR: 'my',
  THB: 'th',
  KRW: 'kr',
  IRR: 'ir',
  TOMAN: 'ir',
  AFN: 'af',
  AZN: 'az',
  AMD: 'am',
};

const FlagIcon = ({ short, flag, size = 26 }) => {
  const code = short ? short.toUpperCase().trim() : '';

  // Check if it's a gold or precious metal asset
  if (flag === '🪙' || code.includes('GOLD') || code.includes('BAHAR') || code.includes('EMAMI') || code.includes('GRAM') || code.includes('SEKE')) {
    return (
      <Box
        component="span"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: size,
          height: size,
        }}
      >
        <i className="fa-solid fa-coins" style={{ color: '#F59E0B', fontSize: size * 0.85 }} />
      </Box>
    );
  }

  // Country flag mapping
  const countryIso = COUNTRY_CODE_MAP[code];

  if (countryIso) {
    return (
      <Box
        component="img"
        src={`https://flagcdn.com/w40/${countryIso}.png`}
        srcSet={`https://flagcdn.com/w80/${countryIso}.png 2x`}
        alt={`${short} flag`}
        sx={{
          width: size,
          height: Math.round(size * 0.72),
          borderRadius: '3px',
          objectFit: 'cover',
          display: 'inline-block',
          verticalAlign: 'middle',
        }}
        onError={(e) => {
          // Fallback if image fails to load
          e.target.style.display = 'none';
        }}
      />
    );
  }

  // Fallback to FontAwesome money icon or raw emoji
  if (flag && flag !== '🌐' && flag !== '🪙') {
    return <span style={{ fontSize: size * 0.85 }}>{flag}</span>;
  }

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
      }}
    >
      <i className="fa-solid fa-money-bill-trend-up" style={{ color: '#3B82F6', fontSize: size * 0.8 }} />
    </Box>
  );
};

export default FlagIcon;
